import styled from "styled-components";
import { Box } from "rebass";

export const ResponsiveIframe = ({ iframe }) => {
  return (
    <Wrap
      dangerouslySetInnerHTML={{ __html: iframe }}
      aria-label="iFrame wrapper"
    />
  );
};

const Wrap = styled(Box)`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;

  iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
`;
